import React, { Fragment, useState } from "react";
import { useParams } from "react-router-dom";
import { mainServices } from "../../../Data/services";
import Footer from "../../Shear/Footer/Footer";
import Header from "../../Shear/Header/Header";
import ServiceDetailsLeft from "./ServiceDetailsLeft";
import ServiceDetailsRight from "./ServiceDetailsRight";
import services from "../../../Assets/Styles/services.module.css";
import RequestAQuoteModal from "../../Shear/Modal/RequestAQuoteModal";
import Head from "../../../layout/Head";
import ScrollToTop from "../../Shear/ScrollToTop";

const ServicesDetails = () => {
  const [open, setOpen] = useState(false);
  const { slug } = useParams();

  const service = mainServices.find((data) => data.slug === slug);

  return (
    <Fragment>
      <Head Title="Services Details" />
      <Header />
      <section>
        <div className="max-lg:max-w-[1000px] max-xl:max-w-[1150px] py-20 gap-7 mx-auto flex justify-center max-lg:flex-row flex-col ">
          <ServiceDetailsLeft services={services} />

          <ServiceDetailsRight service={service} />
        </div>
        <div className="bg-[#0F0F35]">
          <div className="max-lg:max-w-[1000px] px-2 max-sm:gap-5 max-xl:max-w-[1150px] mx-auto py-10 flex flex-col max-lg:flex-row justify-between max-sm:px-20 max-lg:px-0">
            <h2 className="text-[#fff] text-[25px] max-sm:text-3xl font-fira font-bold">
              Looking for the Best IT Business Solutions?
            </h2>
            <button
              onClick={() => setOpen(true)}
              className="custom_button w-60"
              style={{ boxShadow: "none" }}
            >
              {" "}
              Get a quote now
            </button>
          </div>
        </div>
      </section>
      <ScrollToTop/>
      {open && <RequestAQuoteModal setModal={setOpen} />}
      <Footer />
    </Fragment>
  );
};

export default ServicesDetails;
